import { useContext } from 'react';

import { ClientContext } from '/src/graphql/client';

export const useUrqlClient = () => useContext(ClientContext);
